import { SET_STATES, SET_STATE } from "../actionTypes"

const initialState = {
  states: [],
  state: {}
}

const statesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STATES:
      return {
        ...state,
        states: action.states,
      }
    case SET_STATE:
      return {
        ...state,
        state: action.state,
      }
    default:
      return state
  }
}

export default statesReducer